<div
  class="w-full md:pr-6"
  [formGroup]="form">
  <span
    class="font-app-bold text-black cursor-pointer"
    *ngIf="requestNature === RequestNatureOptions.Termination"
    (click)="showTerminationConditionsPopup()">
    <i class="pi pi-arrow-right mr-1 mb-3 text-xs"></i>
    {{ "contactUsForm.termination.conditions" | translate }}
  </span>

  <app-termination-conditions-popup
    [visible]="displayTerminationConditionsPopup"
    (dialogEmitter)="onCloseTerminationConditionsPopup()"></app-termination-conditions-popup>
</div>

<div
  class="relative mt-4 md:mt-5 mb-2"
  [formGroup]="form"
  *ngIf="requestNature === RequestNatureOptions.Termination">
  <label
    for="requestType"
    class="block">
    {{ "contactUsForm.terminationReason.label" | translate }}
    <span class="text-red opacity-60">*</span>
  </label>
  <p-dropdown
    [options]="reasonOptions"
    optionLabel="shortLabel"
    optionValue="code"
    formControlName="selectedTerminationReason"
    (onChange)="onSelectTerminationReason()"
    [placeholder]="'contactUsForm.terminationReason.placeholder' | translate"
    class="mt-1 block w-full border border-1 rounded-md shadow-sm"
    inputId="requestType"
    [panelStyle]="{ width: '100%' }"
    [styleClass]="'relative w-full'"
    appendTo="body">
    <ng-template pTemplate="dropdownicon">
      <i class="pi pi-chevron-down absolute right-2 top-1/2 transform -translate-y-1/2"></i>
    </ng-template>
  </p-dropdown>
</div>

